import { useFolders } from './api-hooks/useFolders';
/** return true if there are no folder with parrent_id=null */
export const useIsProjectEmpty = () => {
  const { data } = useFolders({}, { enabled: false });
  if (!data) return false;
  if (data.length > 0) return false;

  return true;
};
